module.exports = __webpack_public_path__ + "static/media/givenchy-pi-big.f1f0e8ff.png";